<script setup lang="ts">
/**
 * Entry page for the flow
 * --------------------------------------------------------------------------------------------------
 * This page is SERVER-SIDE-RENDERED and serves as a fast-loaded entry point
 * to the product flow. it resets all stores.
 */
definePageMeta({
    layout: 'empty',
    path: '/booking/schynige-platte/start',
    title: 'offerFlow.splashMessage.schynige-platte',
});

onMounted(() => {
    useResetStores().resetOfferFlow();
    useStartFreshFlow().startFreshFlow(productConfigSchynigePlatte);
});
</script>

<template>
    <IntroLoader />
</template>
